/**
 * CORPORATION INCONTI - Futuristic SVG logo
 * Purple "i" + chrome/cyan "C" angular monogram with neon glow.
 */
export default function IncontiLogo({ size = 36, withText = true, compact = false }) {
  return (
    <div className="flex items-center gap-2.5">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ filter: "drop-shadow(0 0 8px rgba(99, 102, 241, 0.55)) drop-shadow(0 0 4px rgba(34, 211, 238, 0.35))" }}
      >
        <defs>
          <linearGradient id="iGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#818CF8" />
            <stop offset="0.5" stopColor="#6366F1" />
            <stop offset="1" stopColor="#3F2A91" />
          </linearGradient>
          <linearGradient id="cGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#22D3EE" />
            <stop offset="1" stopColor="#94A3B8" />
          </linearGradient>
        </defs>

        {/* angular i (left vertical bar with notch) */}
        <path
          d="M8 6 L24 6 L24 14 L20 14 L20 58 L8 58 L8 18 L12 18 L12 14 L8 14 Z"
          fill="url(#iGrad)"
        />

        {/* angular squared C (right side, overlapping center) */}
        <path
          d="M28 12 L56 12 L56 22 L40 22 L40 42 L56 42 L56 52 L28 52 Z"
          fill="url(#cGrad)"
          opacity="0.85"
        />

        {/* accent line */}
        <rect x="28" y="30" width="14" height="3" fill="#22D3EE" opacity="0.7" />
      </svg>

      {withText && !compact && (
        <div className="leading-none">
          <div
            className="font-display font-black text-[15px] tracking-[0.18em]"
            style={{ color: "#A5B4FC" }}
          >
            INCONTI
          </div>
          <div className="label-mono text-[9px] mt-1 tracking-[0.2em]">
            // CORPORATION
          </div>
        </div>
      )}
      {withText && compact && (
        <div
          className="font-display font-black text-sm tracking-[0.2em]"
          style={{ color: "#A5B4FC" }}
        >
          INCONTI
        </div>
      )}
    </div>
  );
}
